'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = generateSelectorPrefix;

var sanitizeComponentDisplayName = function sanitizeComponentDisplayName(cn) {
  return cn.replace(/[^_a-z0-9-]/gi, '_').replace(/_{2,}/g, '_').replace(/(^_|_$)/g, '');
};

function generateSelectorPrefix(displayName, ruleName) {
  var sanitizedDisplayName = sanitizeComponentDisplayName(displayName);
  return ruleName ? sanitizedDisplayName + '_' + ruleName : sanitizedDisplayName;
}